import { createContext } from "react";

const RequestCookiesContext = createContext<Record<string, any>>({});

export default RequestCookiesContext;
